var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 6.77551L12 12.088M12 12.088L2.43746 6.77551M12 12.088L12 22.7755M22.125 16.6539V7.52217C22.125 7.1367 22.125 6.94396 22.0682 6.77207C22.018 6.61999 21.9358 6.4804 21.8273 6.36262C21.7046 6.22949 21.5361 6.13589 21.1992 5.94869L12.8742 1.32369C12.5551 1.14644 12.3956 1.05781 12.2266 1.02306C12.0771 0.992312 11.9229 0.992312 11.7734 1.02306C11.6044 1.05781 11.4449 1.14644 11.1258 1.32369L2.80084 5.94869C2.46388 6.13589 2.2954 6.2295 2.17271 6.36263C2.06418 6.4804 1.98204 6.61999 1.9318 6.77207C1.875 6.94397 1.875 7.1367 1.875 7.52217V16.6539C1.875 17.0394 1.875 17.2321 1.9318 17.404C1.98204 17.5561 2.06418 17.6957 2.17271 17.8135C2.2954 17.9466 2.46388 18.0402 2.80084 18.2274L11.1258 22.8524C11.4449 23.0297 11.6044 23.1183 11.7734 23.153C11.9229 23.1838 12.0771 23.1838 12.2266 23.153C12.3956 23.1183 12.5551 23.0297 12.8742 22.8524L21.1992 18.2274C21.5361 18.0402 21.7046 17.9466 21.8273 17.8135C21.9358 17.6957 22.018 17.5561 22.0682 17.404C22.125 17.2321 22.125 17.0394 22.125 16.6539Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel);
export default __webpack_public_path__ + "static/media/model.0b3d8217eb64f88ff0022cfa138e7bd8.svg";
export { ForwardRef as ReactComponent };